<template>
  <v-dialog
    transition="scale-transition"
    content-class="more-time-modal"
    :scrim="'#212121'"
    :opacity="0.45"
    :model-value="modelValue"
    @click:outside="
      $emit('close-dialog');
      $emit('more-time', false);
    "
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card class="pa-5 dialog more-time-modal__card">
      <v-card-title class=" d-flex justify-end pa-0">
        <v-btn
          class="ms-n1 me-1"
          icon
          variant="text"
          @click="
            $emit('close-dialog');
            $emit('more-time', false);
          "
        >
          <icon height="14" width="14">close-x</icon>
        </v-btn>
      </v-card-title>
      <h3 class="flex-grow-1 text-center">
        Your Order Has Expired
      </h3>
      <v-card-text class="px-0 text-center">
        Would you like more time?
      </v-card-text>
      <v-btn
        color="primary"
        class="more-time-modal__btn mb-3"
        rounded
        size="large"
        variant="flat"
        width="100%"
        @click="
          $emit('more-time', true);
          $emit('close-dialog');
        "
      >
        Yes
      </v-btn>
      <v-btn
        color="surface-variant"
        class="more-time-modal__btn"
        rounded
        size="large"
        variant="outlined"
        width="100%"
        @click="
          $emit('close-dialog');
          $emit('more-time', false);
        "
      >
        No
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'MoretimeModal',
  props: {
    modelValue: {
      type: Boolean,
      default: () => false
    }
  }
};
</script>

<style lang="scss" scoped>
  .v-btn--icon.v-btn--density-default {
    width: 32px;
    height: 32px;
  }
  :deep(.v-card-text) {
    color: rgba(0, 0, 0, .6) !important;
    padding-top: 6px !important;
    padding-bottom: 20px !important;
    font-size: 0.875rem !important;
  }

	.v-dialog {
		width: min(100dvw - 2rem, var(--project-max-width) - 2rem);
		width: 100%;
	}

	.more-time-modal {  
	  &__card {
		max-width: min(100dvw - 2rem, var(--project-max-width) - 2rem);
		max-height: 94%;
		margin: 0;
		border-radius: 2rem !important;
	  }

    h3 {  
      font-size: 1.25rem !important;
      line-height: 1.5625rem!important;
      padding-bottom: 2px;
    }
	}

	:deep(.v-overlay__content) {  
	  max-height: calc(100vh - 48px);
	  max-width: min(480px, calc(100vw - 48px));
	}

  .more-time-modal__btn {
    font-size: 0.875rem !important;
    font-weight: 500;
    letter-spacing: 0.0892857143em;
    min-height: 40px !important;
    height: 40px !important;
  }
</style>
